import {createAction, handleActions} from "redux-actions";
import { Map } from 'immutable';

// action Type
const SET_SITE_ID = 'auth/SET_SITE_ID';
const SET_PASSWORD = 'auth/SET_PASSWORD';
const SET_REMEMBER = 'auth/SET_REMEMBER';

const SET_PREV_PASSWORD = 'auth/SET_PREV_PASSWORD';
const SET_NEW_PASSWORD = 'auth/SET_NEW_PASSWORD';
const SET_NEW_PASSWORD_CONFIRM = 'auth/SET_NEW_PASSWORD_CONFIRM';

const SET_IDID = 'auth/SET_IDID';
const SET_SESSION = 'auth/SET_SESSION';
const SET_PASSWORD_1 = 'auth/SET_PASSWORD_1';
const SET_PASSWORD_2 = 'auth/SET_PASSWORD_2';
const RESET_PW_UPDATE_DATA = 'auth/RESET_PW_UPDATE_DATA';

// action creator
export const setSiteId = createAction(SET_SITE_ID);
export const setPassword = createAction(SET_PASSWORD);
export const setRemember = createAction(SET_REMEMBER);

export const setPrevPassword = createAction(SET_PREV_PASSWORD);
export const setNewPassword = createAction(SET_NEW_PASSWORD);
export const setNewPasswordConfirm = createAction(SET_NEW_PASSWORD_CONFIRM);

export const setIDID = createAction(SET_IDID);
export const setSes = createAction(SET_SESSION);
export const setPassword1 = createAction(SET_PASSWORD_1);
export const setPassword2 = createAction(SET_PASSWORD_2);
export const resetPwUpdateData = createAction(RESET_PW_UPDATE_DATA);

// initial state
const initialState = Map({
    siteid: '',
    password: '',
    remember: false,

    prevPassword: '',
    newPassword: '',
    newPasswordConfirm: '',

    idid: '',
    session: '',
    password1: '',
    password2: '',
});

//reducer
export default handleActions({
    [SET_SITE_ID]: (state, action) => {
        const siteid = action.payload;
        return state.set("siteid", siteid);
    },
    [SET_PASSWORD]: (state, action) => {
        const password = action.payload;
        return state.set("password", password);
    },
    [SET_REMEMBER]: (state, action) => {
        const remember = action.payload;
        return state.set("remember", remember);
    },

    [SET_PREV_PASSWORD]: (state, action) => {
        const prevPassword = action.payload;
        return state.set("prevPassword", prevPassword);
    },
    [SET_NEW_PASSWORD]: (state, action) => {
        const newPassword = action.payload;
        return state.set("newPassword", newPassword);
    },
    [SET_NEW_PASSWORD_CONFIRM]: (state, action) => {
        const newPasswordConfirm = action.payload;
        return state.set("newPasswordConfirm", newPasswordConfirm);
    },

    [SET_IDID]: (state, action) => {
        const idid = action.payload;
        return state.set("idid", idid);
    },
    [SET_SESSION]: (state, action) => {
        const session = action.payload;
        return state.set("session", session);
    },

    [SET_PASSWORD_1]: (state, action) => {
        const password1 = action.payload;
        return state.set("password1", password1);
    },
    [SET_PASSWORD_2]: (state, action) => {
        const password2 = action.payload;
        return state.set("password2", password2);
    },
    [RESET_PW_UPDATE_DATA]: (state, action) => {
        return state
            .set("idid", '')
            .set("session", '')
            .set("password1", '')
            .set("password2", '');
    },
}, initialState)
